import { createReducer, on } from '@ngrx/store';
import { GottenVendorCompaniesEvent } from './vendor-company.events';
import { VendorCompanyState } from './vendor-company.state';

export const vendorCompanyKey = 'vendorCompany';
export const initialState: VendorCompanyState = {
  entities: {},
  byQuery: {},
};

export const VendorCompanyReducer = createReducer(
  initialState,
  // Replace entities for getAll
  on(GottenVendorCompaniesEvent, (state, { entities }) => ({
    ...state,
    entities: entities.reduce((acc, entity) => ({ ...acc, [entity.id]: entity }), {}),
  })),
);
